/**
 * FlyFreely API
 *
 * Contact: support@flyfreely.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface SimpleFlightLogCollectionSourceDto {
    /**
     * The unique ID for this instance
     */
    id: number;
    /**
     * The type of collection source
     */
    type: SimpleFlightLogCollectionSourceDto.Type;
    /**
     * The username, if any, associated with this collection source
     */
    username?: string;
}
export namespace SimpleFlightLogCollectionSourceDto {
    export type Type =
        | 'DJI_CLOUD'
        | 'DJI_FLIGHT_READER'
        | 'DRONE_HARMONY'
        | 'DRONE_DEPLOY'
        | 'SKYDIO'
        | 'FLYT_BASE';
    export const Type = {
        DJI_CLOUD: 'DJI_CLOUD' as Type,
        DJI_FLIGHT_READER: 'DJI_FLIGHT_READER' as Type,
        DRONE_HARMONY: 'DRONE_HARMONY' as Type,
        DRONE_DEPLOY: 'DRONE_DEPLOY' as Type,
        SKYDIO: 'SKYDIO' as Type,
        FLYT_BASE: 'FLYT_BASE' as Type
    };
}
